import React, { useState } from "react";
import { CommonModal, CommonButton } from "../Input";
import { motion, AnimatePresence } from "framer-motion";
import Step0SelectCustomer from "./Withdrawal/Step0SelectCustomer";
import Step1WithdrawalAmount from "./Withdrawal/Step1WithdrawalAmount";
import Step2WithdrawalDenominations from "./Withdrawal/Step2WithdrawalDenominations";
import WithdrawalSuccess from "./Withdrawal/WithdrawalSuccess";

const WithdrawalModal = ({ show, onHide, customer: initialCustomer }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedCustomer, setSelectedCustomer] = useState(initialCustomer);
  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [quantities, setQuantities] = useState({});

  const handleNext = () => {
    if (currentStep < 4) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    handleNext();
  };

  const handleClose = () => {
    setCurrentStep(1);
    setWithdrawalAmount("");
    setQuantities({});
    setSelectedCustomer(initialCustomer);
    onHide();
  };

  const steps = [
    { id: 1, label: "Select Customer" },
    { id: 2, label: "Withdrawal Amount" },
    { id: 3, label: "Enter Denominations" },
    { id: 4, label: "Receipt" },
  ];

  const StepIndicator = ({ currentStep }) => (
    <div className="d-flex align-items-center justify-content-center mb-4 mt-2 w-100 position-relative">
      <div
        className="position-absolute"
        style={{
          height: "1px",
          background: "#eee",
          width: "60%",
          top: "14px",
          zIndex: 0,
        }}
      />
      {steps.map((step, index) => {
        const isActive = step.id === currentStep;
        const isCompleted = step.id < currentStep;

        return (
          <div
            key={step.id}
            className="d-flex flex-column align-items-center position-relative px-4"
            style={{ zIndex: 1 }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center fw-bold fs-12 mb-2"
              style={{
                width: "28px",
                height: "28px",
                backgroundColor:
                  isActive || isCompleted ? "var(--primary)" : "#f8f9fa",
                color: isActive || isCompleted ? "#fff" : "#ccc",
                border: isActive || isCompleted ? "none" : "1px solid #eee",
              }}
            >
              {step.id}
            </div>
            <span
              className="text-center"
              style={{
                fontSize: "11px",
                color: isActive ? "#000" : "#888",
                fontWeight: isActive ? "bold" : "normal",
              }}
            >
              {step.label}
            </span>
          </div>
        );
      })}
    </div>
  );

  return (
    <CommonModal
      show={show}
      onHide={handleClose}
      title="Withdrawal by Cash"
      size="xl"
      fullscreen={true}
      headerClassName="px-4 py-3"
      footer={
        currentStep > 1 && currentStep < 4 ? (
          <div className="d-flex justify-content-end gap-3 w-100 px-3">
            <CommonButton
              variant="outline"
              onClick={handleBack}
            >
              Back
            </CommonButton>
            <CommonButton className="px-5" onClick={handleNext}>
              {currentStep === 2 ? "Next" : "Confirm Withdrawal"}
            </CommonButton>
          </div>
        ) : null
      }
    >
      <div className="px-4 pb-4">
        {currentStep < 4 && <StepIndicator currentStep={currentStep} />}

        <AnimatePresence mode="wait">
          {currentStep === 1 && (
            <motion.div
              key="step0"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <Step0SelectCustomer onSelectCustomer={handleSelectCustomer} />
            </motion.div>
          )}
          {currentStep === 2 && (
            <motion.div
              key="step1"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <Step1WithdrawalAmount
                withdrawalAmount={withdrawalAmount}
                setWithdrawalAmount={setWithdrawalAmount}
                customer={selectedCustomer}
              />
            </motion.div>
          )}
          {currentStep === 3 && (
            <motion.div
              key="step2"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <Step2WithdrawalDenominations
                withdrawalAmount={withdrawalAmount}
                customer={selectedCustomer}
                quantities={quantities}
                setQuantities={setQuantities}
              />
            </motion.div>
          )}
          {currentStep === 4 && (
            <motion.div
              key="step3"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
            >
              <WithdrawalSuccess onBackHome={handleClose} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </CommonModal>
  );
};

export default WithdrawalModal;
